<template>
  <div class="page">
    <home-header activeIndex="3" pageTitle="通知公告" />
    <div class="pageWrap">
      <div class="top">
        <div class="back" @click="back"><a-icon type="left" />返回</div>
        <div class="info">
          <div class="tag">信息来源：{{ detail.nSource }}</div>
          <div class="time">{{ detail.nCtime | dateFilter }}</div>
        </div>
      </div>
      <div class="con">
        <div class="title">{{ detail.nTitle }}</div>
        <div class="content" v-html="detail.nContent"></div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import moment from "moment";
import { getNoticeDetail } from "@/api/notice";
import HomeHeader from "@/components/HomeHeader";
import Footer from "@/components/footer";

export default {
  name: "Home",
  components: {
    HomeHeader,
    Footer,
  },
  data() {
    return {
      id: "",
      detail: {},
      pageTitle: "",
    };
  },
  filters: {
    dateFilter(val) {
      return moment(+val).format("YYYY-MM-DD HH:mm");
    },
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    getNotice() {
      getNoticeDetail({
        id: this.id,
      }).then((res) => {
        this.detail = res;
      });
    },
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getNotice();
  },
};
</script>

<style lang="less" scoped>
.pageWrap {
  width: 1200px;
  min-height: 460px;
  border-radius: 4px;
  background: #fff;
  margin: 20px auto;
  padding: 20px 40px;
}
.top {
  border-bottom: solid 1px #e4e4e4;
  .back {
    color: #2a79ff;
    margin-bottom: 6px;
    cursor: pointer;
    font-size: 16px;
    width: 60px;
  }
  .info {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    color: #666;
    padding: 14px 0;
  }
}
.con {
  .title {
    font-size: 22px;
    color: #333;
    font-weight: 600;
    padding: 20px 0 10px;
  }
}
</style>
